import { ComponentType, SVGProps } from 'react'

import { Card } from '@/entities/auth'
import { Cityscape } from '@/shared/asset'
import { Slot } from '@/shared/lib'
import { Button } from '@/shared/ui'
import LogoKorean from 'public/logo/logo-korean.svg'

type Props = {
  title: string
  content: {
    title: string
    description: string
    image: ComponentType<SVGProps<SVGSVGElement>>
  }[]
  buttonText: string
  onButtonClick: () => void
}

export const SignUpIntro = ({
  title,
  content,
  buttonText,
  onButtonClick,
}: Props) => {
  return (
    <Card className="text-center">
      <Slot name="title">
        <span className="mb-[3px] flex items-center justify-center gap-0.5">
          <LogoKorean className="text-black" />
          <span className="typo-body1 font-medium">에서</span>
        </span>
        <span className="typo-title2 font-semibold">{title}</span>
      </Slot>
      <Slot name="children">
        <ul className="-mt-5 mb-10 space-y-3 px-5 text-left">
          {content.map(({ title, description, image: SVGImage }, index) => (
            <li key={index}>
              <div className="flex items-center gap-10 rounded-sm px-7.5 py-5 shadow-[1px_1px_15px_0_rgba(0,0,0,0.1)]">
                <SVGImage width={58} height={58} />
                <div>
                  <h4 className="typo-body1 mb-2 font-semibold text-black">
                    {title}
                  </h4>
                  <p className="typo-caption1 font-normal whitespace-break-spaces text-gray-600">
                    {description}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ul>
        <Cityscape className="mx-auto" width={286} />
        <Button size="large" fullWidth onClick={onButtonClick}>
          {buttonText}
        </Button>
      </Slot>
    </Card>
  )
}
